export default "/images/ad8daaa7d3f6e0a5baa0d21956c3bf4e.avif";